/**
 * ShellLink — a link into the current dashboards shell that renders as plain
 * text when `href` is null (the id-missing guard), and always stops click /
 * keydown propagation so it doesn't also fire the enclosing clickable row's
 * navigation. Shared by BookingListCard + BookingListTable (BON-130).
 */
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function ShellLink({
  href,
  className,
  children,
}: {
  href: string | null;
  className?: string;
  children: ReactNode;
}) {
  if (!href) return <>{children}</>;
  return (
    <Link
      to={href}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      className={className}
    >
      {children}
    </Link>
  );
}
